import { createContext } from 'react';
import { Options } from '~/helpers/datasetToOptions';

export const OptionsContext = createContext<Options | null>(null);

type OptionsProps = {
  children: React.ReactNode;
  options: Options;
};

export default function OptionsProvider({ children, options }: OptionsProps) {
  return (
    <OptionsContext.Provider value={options}>
      {children}
    </OptionsContext.Provider>
  );
}
